import Hash from "../ui/Hash.vue";
import Block from "../ui/Block.vue";
import Age from "../ui/Age.vue";
import Result from "../ui/Result.vue";

export const columns = [
  {
    key: "hash",
    label: "Hash",
    component: Hash,
    width: "120px",
  },
  { key: "block", label: "Block", width: "80px", component: Block },
  { key: "age", label: "Age", width: "90px", component: Age },
  { key: "from", label: "From", width: "100px", component: Hash },
  { key: "to", label: "To", width: "100px", component: Hash },
  { key: "amount", label: "Amount", width: "80px", component: Age },
  { key: "result", label: "Result", width: "40px", component: Result },
];
